// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.fade-enter-active,\r\n.fade-leave-active {\r\n  -webkit-transition: opacity 0.1s;\r\n  transition: opacity 0.1s;\n}\n.fade-enter,\r\n  .fade-leave-to\r\n  /* .fade-leave-active in <2.1.8 */\r\n\r\n {\r\n  opacity: 0;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
